import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getArticlesAPI } from '../apis/apiBaltee.js';
import Loader from '../components/Loader.js';
import '../styles/ArticleDetail.css';

const ArticleDetail = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const allArticles = await getArticlesAPI();
        const found = allArticles.find(a => a.id === id);
        console.log(found);
        setArticle(found);
      } catch (error) {
        console.error("Erreur lors de la récupération de l'article :", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchArticle();
  }, [id]);

  if (isLoading) return <Loader />;
  if (!article) return <div>Article introuvable.</div>;

  const cleanTitle = article.title.replace(/-/g, ' ').trim();
  const mediaUrl = article.media ? Object.values(article.media)[0] : null;

  return (
    <div className="article-detail">
      {mediaUrl && <img src={mediaUrl} alt={cleanTitle} className="article-detail-image" />}
      <h1>{cleanTitle}</h1>
      <div
        className="article-content"
        dangerouslySetInnerHTML={{ __html: article.content || "<p>Contenu indisponible.</p>" }}
        ></div>
    </div>
  );
};

export default ArticleDetail;
